import React from "react";
import { Link } from "react-router-dom";
import { getBlogPosts, formatBlogDate, BLOG_UI } from "@/content/blogPosts";
import { ArrowLeft, Newspaper, Clock, CalendarDays, ArrowRight } from "lucide-react";
import { useSeoTags } from "@/pages/BlogArticle";
import { useLang } from "@/i18n/LangContext";

export default function Blog() {
  const { lang } = useLang();
  const ui = BLOG_UI[lang] || BLOG_UI.en;
  const posts = getBlogPosts(lang);
  useSeoTags({
    title: `${ui.hubTitle} | Dotec EW-PDF`,
    description: ui.hubSub,
  });
  return (
    <div className="mx-auto max-w-4xl px-6 py-12 lg:px-8" data-testid="blog-hub">
      <div className="mb-6 flex justify-start">
        <Link to="/" data-testid="blog-back-home" className="group inline-flex items-center gap-2 rounded-full border-2 border-emerald-500 bg-emerald-50 px-5 py-2.5 text-sm font-bold text-emerald-700 shadow-sm transition-all hover:-translate-y-0.5 hover:bg-emerald-500 hover:text-white">
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" /> {ui.back}
        </Link>
      </div>
      <div className="mb-10 text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-600"><Newspaper className="h-7 w-7" /></div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">{ui.hubTitle}</h1>
        <p className="mx-auto mt-3 max-w-2xl text-slate-500">{ui.hubSub}</p>
      </div>
      <div className="space-y-5">
        {posts.map((a) => (
          <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group block rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-emerald-300 hover:shadow-md">
            <div className="flex flex-wrap items-center gap-4 text-xs font-semibold text-slate-400">
              <span className="flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" /> {formatBlogDate(a.date, lang)}</span>
              <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" /> {a.minutes} {ui.min}</span>
            </div>
            <h2 className="mt-2 font-display text-xl font-bold text-slate-900 group-hover:text-emerald-700">{a.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{a.meta}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-emerald-600">{ui.read} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
